module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "visible": _vm.dialogVisiable,
      "show-close": true,
      "center": true,
      "before-close": _vm.closeDialog,
      "append-to-body": _vm.appendToDialog,
      "close-on-click-modal": false,
      "custom-class": "approval-dialog",
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiable = $event
      }
    }
  }, [_c('div', {
    staticClass: "approval-info"
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.type === 'confirm' ? 'icon-shenpitongguo' : 'icon-shenpijujue'
  }), _vm._v(" "), _c('span', [_vm._v("审批" + _vm._s(_vm.type == 'confirm' ? '通过' : '拒绝') + "　　")])]), _vm._v(" "), _c('div', {
    staticClass: "apprvoal-reason"
  }, [_c('el-input', {
    attrs: {
      "maxlength": "200",
      "type": "textarea",
      "placeholder": '请输入审批' + (_vm.type == 'confirm' ? '通过' : '拒绝') + '理由（选填）'
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirmOK
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.confirm")))])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-406147de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-406147de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ApprovalDialog.vue
// module id = 1566
// module chunks = 7